<template>
  <div class="padding-md">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="应用名称">
            <el-input v-model="searchForm.appName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="loadData">查询</el-button>
            <el-button type="success" @click="showDialog(false)">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table
          :data="apps"
          :stripe="true"
          v-loading="loading"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            width="80"
            label="ID">
          </el-table-column>
          <el-table-column prop="appName" label="应用名称"></el-table-column>
          <el-table-column prop="appIndex" label="应用索引"></el-table-column>
          <el-table-column prop="openMark" label="应用URL标识"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="160" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showDialog(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteApp(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog el-dialog :title="title" :visible.sync="showEditorDialog" class="update" :before-close="handleBeforeCloseDialog">
      <el-form :model="formData" ref="formData" label-width="80px" :rules="formRules">
        <el-form-item prop="appName" class="form-item__full-width" label="应用名称" placeholder="请输入应用名称">
          <el-input type="text" v-model.trim="formData.appName"></el-input>
        </el-form-item>
        <el-form-item label="应用索引" prop="appIndex">
          <el-input type="number" v-model.trim="formData.appIndex" :disabled="!!formData.id"></el-input>
        </el-form-item>
        <el-form-item label="URL标识" prop="openMark">
          <el-input type="text" v-model.trim="formData.openMark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit" @click.native.prevent="handleSubmit('formData')">保存</el-button>
          <el-button @click="closeDialog">返回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

  import {
    getApps,
    saveApp,
    updateApp,
    deleteApp
  } from '@/api/apps';

  function defaultForm () {
    return {
      appName: null,
      appIndex: 0,
      openMark: null
    };
  }

  export default {
    name: 'apps',
    data () {
      return {
        loading: true,
        apps: [],
        title: '',
        showEditorDialog: false,
        formData: defaultForm(),
        searchForm: {
          appName: null
        },
        formRules: {
          appName: [{required: true, trigger: 'blur', message: '请输入应用名称'}],
          appIndex: [{required: true, trigger: 'blur', message: '应用Index只能输入数字'}],
          openMark: [{required: true, trigger: 'blur', message: '请输入应用URL标识'}]
        }
      };
    },
    /**
     * 初始化钩子
     */
    created () {
      this.loadData();
    },
    methods: {
      /**
       *根据条件查询
       */
      loadData () {
        this.loading = true;
        getApps({
          ...this.searchForm
        }).then(result => {
          this.loading = false;
          this.apps = result;
        }).catch(() => {
          this.loading = false;
        });
      },

      /**
       * 打开编辑面板
       */
      showDialog (obj) {
        this.showEditorDialog = true;
        if (!obj) {
          this.title = '添加应用';
          this.formData = defaultForm();
        } else {
          this.title = '修改应用信息';
          this.formData = {
            ...obj
          };
        }

      },
      /**
       * 关闭面板
       */
      closeDialog () {
        this.clearForm();
        this.showEditorDialog = false;
      },
      clearForm () {
        this.$refs['formData'].resetFields();
      },

      handleBeforeCloseDialog (done) {
        this.clearForm();
        done();
      },

      /**
       * 提交前验证
       */
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.saveApp();
          } else {
            this.$message.error('提交失败');
            return false;
          }
        });
      },
      /**
       * 保存应用
       */
      saveApp () {
        const loading = this.$loading();
        if (this.formData.id) {
          updateApp(this.formData).then(result => {
            this.showEditorDialog = !this.showEditorDialog;
            loading.close();
            if (result) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.loadData();
            }
          }).catch(() => loading.close());
        } else {
          saveApp(this.formData).then(() => {
            this.showEditorDialog = !this.showEditorDialog;
            loading.close();
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.loadData();
          }).catch(() => loading.close());
        }
      },
      /**
       * 删除
       */
      deleteApp (obj) {
        this.$confirm('确认删除该应用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading();
          deleteApp(obj.id).then(result => {
            loading.close();
            if (result > 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.loadData();
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .update {
    margin-top: 10px;
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      display: block;
    }
    .img-box {
      width: 100px;
      height: 100px;
    }
    .number-input {
      width: 195px;
    }

    .form-item__full-width .el-select,
    .form-item__full-width .el-input-number {
      width: 100%;
    }

  }
</style>

<style>
  /*这里是elementUI组件自动生成的元素*/

  .el-upload-dragger {
    width: 100px;
    height: 100px;
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
</style>




// WEBPACK FOOTER //
// apps.vue?0483710f